import * as React from 'react';

export const useHover = () => {
  const [isHovered, changeIsHovered] = React.useState<boolean>(false);

  const close = () => changeIsHovered(false);
  const open = () => changeIsHovered(true);
  const toggle = () => changeIsHovered(!isHovered);

  const onHoverProps = {
    onMouseEnter: () => open(),
    onMouseLeave: () => close(),
    onTouchStart: () => toggle(),
  };

  return {
    isHovered,
    onHoverProps,
  };
};
